import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHorizontalAlignmentCenter"><Path d="M3.5 12H6.5M17.5 12H20.5M10.5 12H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 4.5V19.5H10.5V4.5H6.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 6.5V17.5H17.5V6.5H13.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHorizontalAlignmentCenter;
